'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import CloseIcon from '@/fo/icons/base/icons/cross32.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';

import { CommentForm } from '../components/CommentForm/CommentForm';
import { SuccessMessage } from '../components/SuccessMessage/SuccessMessage';

import { styles } from './FeatureCommentFormBase.styles';

export interface FeatureCommentFormBaseProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  postId: number;
}

export function FeatureCommentFormBase({
  onOpenChange,
  open,
  postId
}: FeatureCommentFormBaseProps) {
  const slots = styles();
  const t = useTranslations();

  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsSuccess(false);
    }
  }, [open]);

  return (
    <UiKitDrawerBase
      title={t('comment.addComment')}
      open={open}
      direction="right"
      withoutMobile
      onOpenChange={onOpenChange}
      handleOnly
      contentClassName={slots.content()}
      closeButtonClassName={slots.closeButton()}
    >
      <div className={slots.base()}>
        <div className={slots.header()}>
          {!isSuccess ? (
            <h2 className={slots.title()}>{t('comment.addComment')}</h2>
          ) : (
            <div />
          )}
          <UiKitButtonBase
            color="ghost"
            rounded="full"
            className={slots.mobileCloseButton()}
            onClick={() => onOpenChange(false)}
          >
            <CloseIcon className={slots.closeIcon()} />
          </UiKitButtonBase>
        </div>

        <div className={slots.form()}>
          {isSuccess ? (
            <SuccessMessage onClick={() => onOpenChange(false)} />
          ) : (
            <CommentForm
              postId={postId}
              onSuccess={() => setIsSuccess(true)}
              onClose={() => onOpenChange(false)}
            />
          )}
        </div>
      </div>
    </UiKitDrawerBase>
  );
}
